import '.bn{position:relative;}.ssr-plugin'
import '.i1{width:64px;}.ssr-plugin'
import '.i2{height:64px;}.ssr-plugin'
import '.c2{flex-shrink:0;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.i3{bottom:-4px;}.ssr-plugin'
import '.ch{right:-4px;}.ssr-plugin'
import '.dk{border-radius:50%;}.ssr-plugin'
import '.i4{border:2px solid var(--shades-white);}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.i5{width:32px;}.ssr-plugin'
import '.i6{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bn i1 i2 c2"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="a6 i3 ch dk i4 aa i5 i6"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
